// Generated by purs version 0.15.15
var FStyleNormal = /* #__PURE__ */ (function () {
    function FStyleNormal() {

    };
    FStyleNormal.value = new FStyleNormal();
    return FStyleNormal;
})();
var FStyleItalic = /* #__PURE__ */ (function () {
    function FStyleItalic() {

    };
    FStyleItalic.value = new FStyleItalic();
    return FStyleItalic;
})();
var FStyleOblique = /* #__PURE__ */ (function () {
    function FStyleOblique() {

    };
    FStyleOblique.value = new FStyleOblique();
    return FStyleOblique;
})();
var showFontStyle = {
    show: function (v) {
        if (v instanceof FStyleNormal) {
            return "FStyleNormal";
        };
        if (v instanceof FStyleItalic) {
            return "FStyleItalic";
        };
        if (v instanceof FStyleOblique) {
            return "FStyleOblique";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStyle (line 16, column 10 - line 19, column 37): " + [ v.constructor.name ]);
    }
};
var printFontStyle = function (v) {
    if (v instanceof FStyleNormal) {
        return "normal";
    };
    if (v instanceof FStyleItalic) {
        return "italic";
    };
    if (v instanceof FStyleOblique) {
        return "oblique";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStyle (line 22, column 18 - line 25, column 29): " + [ v.constructor.name ]);
};
var eqFontStyle = {
    eq: function (x) {
        return function (y) {
            if (x instanceof FStyleNormal && y instanceof FStyleNormal) {
                return true;
            };
            if (x instanceof FStyleItalic && y instanceof FStyleItalic) {
                return true;
            };
            if (x instanceof FStyleOblique && y instanceof FStyleOblique) {
                return true;
            };
            return false;
        };
    }
};
export {
    FStyleNormal,
    FStyleItalic,
    FStyleOblique,
    printFontStyle,
    eqFontStyle,
    showFontStyle
};
